export default __webpack_public_path__ + "static/media/mail.3d7a4229.svg";